import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Media } from '@promo/const';
import { ScrollToService } from '@shared/v2';
import { RouterState, RoutingService, WindowRef } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * `SdvorLogoComponent` используется для отображения логотипа компании
 *
 * ```ts
 * import { SdvorLogoComponent } from '@sdvor/shared/ui/v2';
 * ```
 */
@Component({
  selector: 'sd-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  imports: [AsyncPipe, RouterLink, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorLogoComponent implements OnInit {
  @Input() tabbar: boolean;
  /** @ignore */
  media: Media;
  /** @ignore */
  semanticRoute$: Observable<string | undefined>;

  constructor(
    private routingService: RoutingService,
    private windowRef: WindowRef,
    private scrollToService: ScrollToService,
  ) {}

  /** @ignore */
  ngOnInit(): void {
    this.semanticRoute$ = this.routingService
      .getRouterState()
      .pipe(map((routerState: RouterState) => routerState.state.semanticRoute));
  }

  scrollToTop(): void {
    if (!this.windowRef.isBrowser()) {
      return;
    }

    this.scrollToService.scrollToTop();
  }
}
